import React, { lazy } from "react";

import { Route, Switch, useRouteMatch, useLocation } from "react-router-dom";

import HeaderRouter from "./HeaderRouter";

import { CssBaseline } from "@material-ui/core";

import { ordersStyles } from "../styles/ordersStyles";
import { Suspense } from "react";

const Base = lazy(() => import("./base"));
const Employees = lazy(() =>
  import("../Pages/system-management/Employees/Employees")
);
const History = lazy(() => import("../Pages/orders/history/History"));
const RejectedOrders = lazy(() =>
  import("../Pages/orders/rejected_orders/rejected_orders")
);
const PageNotFound = lazy(() => import("./404"));
const UsersGroup = lazy(() =>
  import("../Pages/system-management/user-groups/UsersGroup")
);
const Transactions = lazy(() =>
  import("../Pages/orders/transactions/Transactions")
);
const NewOrders = lazy(() => import("../Pages/orders/newOrders/NewOrders"));
const NewGroup = lazy(() =>
  import("../Pages/system-management/user-groups/NewGroup")
);
const Accessbilities = lazy(() =>
  import("../Pages/system-management/accessbilities/Accessbilities")
);
const NewEmployee = lazy(() =>
  import("../Pages/system-management/Employees/NewEmployee")
);
const ReadyOrders = lazy(() =>
  import("../Pages/orders/readyOrders/ReadyOrders")
);
const Profile = lazy(() => import("../Pages/profile/Profile"));

const MainBody = () => {
  const { path } = useRouteMatch();
  const classes = ordersStyles();
  const location = useLocation();

  let Routes = [
    { path: "profile", comp: Profile, exact: false },
    { path: "", comp: Base, exact: true },
    { path: "orders/newOrders", comp: NewOrders, exact: true },

    { path: "orders/readyToSend", comp: ReadyOrders, exact: true },
    { path: "orders/rejected_delivery", comp: RejectedOrders, exact: true },
    { path: "orders/history", comp: History, exact: true },
    { path: "orders/transactions", comp: Transactions, exact: true },
    { path: "system-manegment/employees", comp: Employees, exact: true },
    {
      path: "system-manegment/employees/newEmployee",
      comp: NewEmployee,
      exact: true,
    },
    {
      path: "system-manegment/users-group",
      comp: UsersGroup,
      exact: true,
    },
    {
      path: "system-manegment/users-group/new-group",
      comp: NewGroup,
      exact: true,
    },
    {
      path: "system-manegment/accessibilities",
      comp: Accessbilities,
      exact: false,
    },
  ];

  return (
    <>
      <CssBaseline />
      <div className={classes.orderRoot} style={{}}>
        <HeaderRouter />
      </div>

      <div className={classes.orderRoot} style={{ height: "100%" }}>
        <Suspense fallback={<span></span>}>
          <Switch location={location} key={location.key}>
            {Routes.map((item, i) => {
              return (
                <Route key={i} exact={item.exact} path={`${path}${item.path}`}>
                  {<item.comp />}
                </Route>
              );
            })}
            <Route component={PageNotFound} path="*" />
          </Switch>
        </Suspense>
      </div>
    </>
  );
};

export default MainBody;
